import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled, { css } from 'styled-components';
import { marginAttributes, propsBlocker, getComponentOverride, color, reset, typography, spacing, pixelToRem } from '../../../system';

var getRootStyle = function getRootStyle(_ref) {
  var disabled = _ref.disabled,
      size = _ref.size,
      lead = _ref.lead,
      subtitle = _ref.subtitle,
      divider = _ref.divider;
  var result = {};

  if (disabled) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n            cursor: not-allowed;\n            &:hover {\n                background: ", ";\n            }\n        "])), result, color('neutral.04'), color('neutral.00'));
  } else {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            &:hover {\n                background-color: ", ";\n                .PrimaryIconWrapper-Root {\n                    border: 1px solid ", ";\n                    box-sizing: border-box;\n                    border-radius: ", ";\n                }\n            }\n        "])), result, color('primary.lightest'), color('primary.lighter'), spacing(2));
  }

  if (divider) {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            &:not(:last-child) {\n                border-bottom-width: 0.5px;\n                border-bottom-style: solid;\n                color: ", ";\n            }\n        "])), result, color('neutral.03'));
  }

  if (size === 'small') {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            min-height: ", ";\n            padding: ", " ", ";\n        "])), result, spacing(8), spacing(2), spacing(2));
  } else if (size === 'medium') {
    result = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            ", ";\n            min-height: ", ";\n            padding: ", " ", ";\n        "])), result, spacing(6), spacing(3), spacing(3));
  } else if (size === 'large') {
    result = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            ", ";\n            min-height: ", ";\n            padding: ", " ", ";\n        "])), result, spacing(10), spacing(4), spacing(4));
  }

  if (lead || subtitle) {
    result = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            ", ";\n            min-height: ", ";\n            padding: ", " ", ";\n        "])), result, spacing(15.5), spacing(4), spacing(4));
  }

  return result;
};

var getSecondaryListStyle = function getSecondaryListStyle(_ref2) {
  var lead = _ref2.lead,
      disabled = _ref2.disabled;
  var result = {};

  if (lead) {
    result = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            ", ";\n            display: flex;\n            align-self: flex-end;\n        "])), result);
  }

  if (disabled) {
    result = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color('neutral.04'));
  } else {
    result = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color('neutral.05'));
  }

  return result;
};

var getLeadSubtitleStyle = function getLeadSubtitleStyle(_ref3) {
  var disabled = _ref3.disabled;
  var result = {};

  if (disabled) {
    result = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color('neutral.04'));
  } else {
    result = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color('neutral.05'));
  }

  return result;
};

var getPrimaryListStyle = function getPrimaryListStyle(_ref4) {
  var lead = _ref4.lead,
      disabled = _ref4.disabled;
  var result = {};

  if (lead) {
    result = css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n            ", ";\n            margin-top: 0;\n        "])), result);
  }

  if (disabled) {
    result = css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color('neutral.04'));
  } else {
    result = css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color('neutral.06'));
  }

  return result;
};

var Wrapper = function Wrapper(_ref5) {
  var children = _ref5.children,
      restProps = _objectWithoutProperties(_ref5, _excluded);

  return children(_objectSpread({}, restProps));
};

export var ListItemRoot = styled(Wrapper).withConfig(propsBlocker)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n\n    display: flex;\n    text-decoration: none;\n    flex-direction: row;\n    align-items: center;\n    align-content: center;\n    justify-content: space-between;\n    max-height: fit-content;\n    font-size: inherit;\n    border-radius: 0;\n    background: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n"])), reset, typography('paragraphMedium'), color('neutral.00'), getRootStyle, getComponentOverride('ListItem'), marginAttributes);
export var PrimaryListItem = styled.div.withConfig(propsBlocker)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    align-self: flex-start;\n    justify-content: center;\n    ", ";\n"])), getPrimaryListStyle);
export var SecondaryListItem = styled.div.withConfig(propsBlocker)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    align-self: flex-start;\n    justify-content: center;\n    color: ", ";\n    ", ";\n"])), color('neutral.05'), getSecondaryListStyle);
export var PrimaryIconContainer = styled.div.withConfig(propsBlocker)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n    margin-top: ", ";\n    min-height: fit-content;\n"])), spacing(4), spacing(0.25));
export var ActionsContainer = styled.div.withConfig(propsBlocker)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n    margin-top: ", ";\n"])), spacing(2), spacing(0.25));
export var PrimaryLeadSubtitle = styled.div.withConfig(propsBlocker)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-self: flex-start;\n    font-size: ", ";\n    ", "\n"])), pixelToRem(14), getLeadSubtitleStyle);
export var PrimaryListItemContainer = styled.div.withConfig(propsBlocker)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"])));